module.exports = __webpack_public_path__ + "static/Caley-main-mobile-6f442c8f1b8fc2f678d86619092cc043.png";